import { ConcreteEncodable } from "./ConcreteEncodable";

import { LinkedOrderModificationRequestImplEncoder } from "../../encoder/LinkedOrderModificationRequestImplEncoder";

import * as CubiqTS from "../../index";
import { LinkedOrderModificationRequest } from "../LinkedOrderModificationRequest";
import { v4 as uuid } from "uuid";

export class LinkedOrderModificationRequestImpl
  extends ConcreteEncodable
  implements LinkedOrderModificationRequest
{
  public static enType: string = "com.bcdfx.model.event.LinkedOrderModificationRequestImpl";

  /*FID=1*/
  public product: CubiqTS.Product;
  /*FID=2*/
  public comment1: string;
  /*FID=3*/
  public comment2: string;
  /*FID=4*/
  public client: string;
  /*FID=5*/
  public account: string;
  /*FID=6*/
  public linkReference: string;
  /*FID=7*/
  public rootOrder: CubiqTS.OrderRequestDataImpl;
  /*FID=9*/
  public clientTrader: string;
  /*FID=10*/
  public stpHold: boolean;
  /*FID=11*/
  public savedOrder: boolean;
  /*FID=12*/
  public oboClient: string;
  /*FID=13*/
  public oboAccount: string;
  /*FID=14*/
  public oboUser: string;
  /*FID=100*/
  public messageId: string;
  /*FID=101*/
  public cancelAndReplace: boolean;
  /*FID=102*/
  public privatisedRequest: boolean;
  /*FID=103*/
  public clientReference: string;
  /*FID=104*/
  public existingOrderReference: string;
  /*FID=105*/
  public makerReference: string;
  /*FID=106*/
  public clientStrategyReference: string;
  /*FID=107*/
  public existingStrategyReference: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken;

  constructor() {
    super();
    this.encoder = LinkedOrderModificationRequestImplEncoder.Instance;
    this.setEncodableType(LinkedOrderModificationRequestImpl.enType);
    this.messageId = uuid();
  }

  public toString(): string {
    return (
      "LinkedOrderModificationRequestImpl[" +
      "product=" +
      this.product +
      "comment1=" +
      this.comment1 +
      "comment2=" +
      this.comment2 +
      "client=" +
      this.client +
      "account=" +
      this.account +
      "linkReference=" +
      this.linkReference +
      "rootOrder=" +
      this.rootOrder +
      "clientTrader=" +
      this.clientTrader +
      "stpHold=" +
      this.stpHold +
      "savedOrder=" +
      this.savedOrder +
      "oboClient=" +
      this.oboClient +
      "oboAccount=" +
      this.oboAccount +
      "oboUser=" +
      this.oboUser +
      "cancelAndReplace=" +
      this.cancelAndReplace +
      "privatisedRequest=" +
      this.privatisedRequest +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
